import { render, staticRenderFns } from "./seriesEditModel.vue?vue&type=template&id=0b220af5"
import script from "./seriesEditModel.vue?vue&type=script&lang=js"
export * from "./seriesEditModel.vue?vue&type=script&lang=js"
import style0 from "./seriesEditModel.vue?vue&type=style&index=0&id=0b220af5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports